import { BeneficioService } from "services/comunicacion-cultura";
import { beneficiosAtom, beneficiosHistoricoAtom, beneficiosPendientesAprobacionAtom, openModalSolicitarBeneficioAtom } from "../store/store";
import { useAtom } from "jotai";

const useBeneficiosPage = () => {

    const [open, setOpen] = useAtom(openModalSolicitarBeneficioAtom);
    const [beneficios, setBeneficios] = useAtom(beneficiosAtom);
    const [beneficiosPendientesAprobacion, setBeneficiosPendientesAprobacion] = useAtom(beneficiosPendientesAprobacionAtom);
    const [beneficiosHistorico, setBeneficiosHistorico] = useAtom(beneficiosHistoricoAtom);

    const abrirModal = () => {
        setOpen(true);
    }

    const cerrarModal = () => {
        setOpen(false);
    }

    const fetchBeneficios = async () => {
        const beneficios = await BeneficioService.listar();
        setBeneficios(beneficios);
    }

    const fetchBeneficiosPendientesAprobacion = async () => {
        const beneficios = await BeneficioService.listarPendientesAprobacion();
        setBeneficiosPendientesAprobacion(beneficios);
    }

    const fetchBeneficiosHistorico = async () => {
        const data = await BeneficioService.listarHistorico();
        setBeneficiosHistorico(data);
    }

    return {
        open,
        beneficios,
        beneficiosPendientesAprobacion,
        beneficiosHistorico,
        abrirModal,
        cerrarModal,
        fetchBeneficios,
        fetchBeneficiosPendientesAprobacion,
        fetchBeneficiosHistorico
    };
};

export default useBeneficiosPage;